import { render, staticRenderFns } from "./ClassListFilters.vue?vue&type=template&id=8fa4e190&"
import script from "./ClassListFilters.vue?vue&type=script&lang=js&"
export * from "./ClassListFilters.vue?vue&type=script&lang=js&"
import style0 from "./ClassListFilters.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports